// extracted by css-extract-rspack-plugin
export default {"button":"_b770a889","arrow":"_a14bcf26","isHidden":"_ff13c6cf","arrowLeft":"_300bc43d","arrowRight":"_95f042e6","hideScrollbar":"_f639dfe3","shadowLine":"_7f735737"};